import { DEFAULT_APP_STATE, ITheme } from '../context/AppContext'
import { createCompanyTheme } from '../styles/colors'

const STORAGE_KEY = 'summCompanyColors'

// The last loaded company's colours, so a reload paints the skeleton and app in
// them instead of the SUMM defaults until the company itself has loaded.
export const getInitialTheme = (): ITheme => {
  try {
    const cached = localStorage.getItem(STORAGE_KEY)
    return cached
      ? createCompanyTheme(JSON.parse(cached))
      : DEFAULT_APP_STATE.theme
  } catch {
    return DEFAULT_APP_STATE.theme
  }
}

export const cacheCompanyColors = (companyColors: {
  [key: string]: number[]
}) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(companyColors))
  } catch {
    // Storage unavailable (private mode, quota): the next reload starts in the defaults
  }
}

// On logout, so the next user on this browser doesn't start in another company's colours
export const clearCachedCompanyColors = () => {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Storage unavailable: nothing was cached
  }
}
